import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import OutsideClickHandler from 'react-outside-click-handler';
import Button from '@material-ui/core/Button';
import '../scss/style.scss';
import threeDotsIcon from '../img/three-dots.svg';
import flagFilter from './../../helpers/flagFilter';
const useStyles = makeStyles((theme) => ({
    root: {
        position: 'relative',
        maxWidth: 200,
    },
    dropdown: {
        position: 'absolute',
        top: 28,
        minWidth: 'auto',
        // padding: 10,
        zIndex: 1,
    },
}));

export default function ClickAway(props) {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);

    const handleClick = () => {
        setOpen((prev) => !prev);
    };
    const handleClickAway = () => {
        setOpen(false);
    };
    const dropdownItemHandler = (dropdownItem) => {
        handleClickAway();
        props.updateCurrency(dropdownItem);
    }
    return (
        <OutsideClickHandler onOutsideClick={handleClickAway}>
            <div className={classes.root}>
                <Button aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick} className="dashboard-currency-convertor-data-currency">
                    <span>{props.currency}</span>
                    <img src={flagFilter(props.currency)} alt="" className="dashboard-currency-convertor-data-currency-image-right" />
                </Button>
                {open ?
                    <div className={classes.dropdown + " dropdown-button-operation-list"}>{
                        props.dropdownItems.map((dropdownItem, index) => (
                            <div className="dropdown-button-operation-link" onClick={() => dropdownItemHandler(dropdownItem, index)} key={index} >
                                <div className="dashboard-currency-convertor-data-currency dropdown-button-operation-item">
                                    <img src={flagFilter(dropdownItem)} alt="" className="dashboard-currency-convertor-data-currency-image dashboard-currency-convertor-data-currency-image-left"/>
                                    <span>{dropdownItem}</span>
                                </div>
                            </div>
                        ))
                    }
                    </div>
                    : null}
            </div>
        </OutsideClickHandler>
    );
}